import { Controller } from "@hotwired/stimulus"

// Opens the accordion panel named in the URL hash (e.g. #panelSystemPrompt)
// on load. Config save actions redirect back with that anchor so the panel
// the user was working in reopens instead of the accordion collapsing.
//
// connect() runs on initial load and on every Turbo navigation, so this
// replaces the hand-rolled readyState/inline-script approach.
export default class extends Controller {
  connect() {
    this.openPanelFromHash()
  }

  openPanelFromHash() {
    const hash = window.location.hash
    if (!hash) return

    const panel = this.element.querySelector(hash)
    if (!panel || !panel.classList.contains("accordion-collapse")) return

    const button = this.element.querySelector(`[data-bs-target="${hash}"]`)
    if (!button) return

    if (window.bootstrap && window.bootstrap.Collapse) {
      window.bootstrap.Collapse.getOrCreateInstance(panel, { toggle: false }).show()
    } else if (button.classList.contains("collapsed")) {
      button.click()
    }

    setTimeout(() => {
      button.scrollIntoView({ behavior: "smooth", block: "start" })
      button.focus({ preventScroll: true })
    }, 50)
  }
}
